import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EntityKey } from '../entity/entity';
import { GoogleService } from './google-service';
import { EntityLineRevisionChange } from '../model/entity-line-revision-change';

@Service()
export class EntityLineRevisionChangeService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);
  private urlBase = environment.serviceUrl + 'entityLineRevisionChange/';

  getEntityUpdates(key: EntityKey): Observable<EntityLineRevisionChange[]> {
    const url = this.urlBase + 'entityUpdates/' + key.entityId + '/' + key.entityRevision;
    return this.http.get<EntityLineRevisionChange[]>(url, { headers: this.getRequestHeaders() });
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  saveChanges(changes: EntityLineRevisionChange[]): Observable<string> {
    const url = this.urlBase + 'save';
    const body = JSON.stringify(changes);
    return this.http.post(url, body, { headers: this.getPostHeaders(), responseType: 'text' });
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set('Content-Type', 'application/json');
  }
}
